import React from 'react';
import { AnnouncementBar } from '../components/founding/AnnouncementBar';
import { BookCallButton } from '../components/founding/BookCallButton';
import { FaqSection } from '../components/founding/FaqSection';
import { FoundingFooter } from '../components/founding/FoundingFooter';
import { FoundingHero } from '../components/founding/FoundingHero';
import { FoundingInvitation } from '../components/founding/FoundingInvitation';
import { ImmersiveExperiencePillars } from '../components/founding/ImmersiveExperiencePillars';
import { MeetFounder } from '../components/founding/MeetFounder';
import { MemberBenefits } from '../components/founding/MemberBenefits';
import { TrustSection } from '../components/founding/TrustSection';
import { WhoItsFor } from '../components/founding/WhoItsFor';
import { WhyItMattersNow } from '../components/founding/WhyItMattersNow';
import { WorkInProgress } from '../components/founding/WorkInProgress';
export function FoundingMembersPage() {
  return <div className="min-h-screen w-full scroll-smooth bg-[#08070A] text-[#FDFBF7] selection:bg-[#D4AF37] selection:text-[#08070A]" data-id="element-4202" data-mp="29oeghnialren">
      <AnnouncementBar data-id="element-4203" data-mp="2emg1wf36y2ta" />
      <header className="sticky top-0 z-40 border-b border-[#D4AF37]/15 bg-[#08070A]/95 backdrop-blur" data-id="element-4204" data-mp="2elxz0zm0wqce">
        <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between gap-4 px-5 sm:px-8" data-id="element-4205" data-mp="2jndg6gl2ycpi">
          <span className="font-serif text-sm uppercase tracking-[0.28em] text-[#FDFBF7]" data-id="element-4206" data-mp="2nm324xk6p2kr">
            Sikh Kingdoms
          </span>
          <BookCallButton size="sm" data-id="element-4207" data-mp="1vwhu803b2bq6">
            <span className="hidden sm:inline" data-id="element-4208" data-mp="1vxj6g7w2549h">Book a Call</span>
            <span className="sm:hidden" data-id="element-4209" data-mp="1zy32170zfzti">Book</span>
          </BookCallButton>
        </div>
      </header>

      <main data-id="element-4210" data-mp="24pl3dw6x42f0">
        <FoundingHero data-id="element-4211" data-mp="24qcy74soxw48" />
        <ImmersiveExperiencePillars data-id="element-4212" data-mp="24qmf82vrcsxs" />
        <WhyItMattersNow data-id="element-4213" data-mp="187oudsjkbjqa" />
        <FoundingInvitation data-id="element-4214" data-mp="1888ad3pnjy1o" />
        <MemberBenefits data-id="element-4215" data-mp="1876pk7iu3x6r" />
        <WhoItsFor data-id="element-4216" data-mp="185m4d8ietqlk" />
        <WorkInProgress data-id="element-4217" data-mp="1c8s7i7a871nt" />
        <TrustSection data-id="element-4218" data-mp="1c7z1x9n06i79" />
        <MeetFounder data-id="element-4219" data-mp="1c77fopfapwtn" />
        <FaqSection data-id="element-4220" data-mp="1c6ny59tk5ag5" />
      </main>

      <FoundingFooter data-id="element-4221" data-mp="2fj63yyloqv9r" />

      <div className="fixed inset-x-0 bottom-0 z-50 border-t border-[#D4AF37]/25 bg-[#08070A]/95 p-3 backdrop-blur md:hidden" data-id="element-4222" data-mp="2fimv07e0jh7v">
        <BookCallButton className="w-full" data-id="element-4223" data-mp="2aiqre9989rsu">Book a Founding Member Call</BookCallButton>
      </div>
    </div>;
}